const en = {
	availableFields: "available fields",
	values: "data",
	columns: "columns",
	rows: "rows",
	moveFieldsHere: "MOVE FIELDS HERE",
	hideSettings: "Hide Settings",
	showSettings: "Show Settings",
	apply: "Apply",
	day: "Day",
	week: "Week",
	month: "Month",
	quarter: "Quarter",
	year: "Year",
	min: "Min",
	max: "Max",
	sum: "Sum",
	count: "Count",
	equal: "Equal",
	notEqual: "Not Equal",
	contains: "Contains",
	notContains: "Not Contains",
	typeHere: "Type Here",
	selectAll: "Select All",
	unselectAll: "Unselect All",
	cancel: "Cancel",
	ok: "Ok",
	total: "Total",
	date: {
		monthFull: [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December",
		],
		monthShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
		dayFull: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
		dayShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
		quarter: ["Q1", "Q2", "Q3", "Q4"],
		week: "W",
	},
	types: {
		operations: [
			{ id: "sum", label: "sum" },
			{ id: "min", label: "min" },
			{ id: "max", label: "max" },
			{ id: "count", label: "count" },
		],
		dates: [
			{ id: "dateByDay", label: "day" },
			{ id: "dateByWeek", label: "week" },
			{ id: "dateByMonth", label: "month" },
			{ id: "dateByQuarter", label: "quarter" },
			{ id: "dateByYear", label: "year" },
		],
	},
};

export default en;
